let env = ''
if (process.env.CUSTOM_ENV === 'test') {
  env = 'test.'
} else if (process.env.CUSTOM_ENV === 'dev') {
  env = 'dev.'
} else if (process.env.CUSTOM_ENV === 'beta') {
  env = 'beta.'
}
let template = 'ap'
if (process.env.CUSTOM_ENV === 'test') {
  template = 'test.tp'
} else if (process.env.CUSTOM_ENV === 'dev') {
  template = 'dev.tp'
} else if (process.env.CUSTOM_ENV === 'beta') {
  template = 'beta.ap'
}
let wss = 'wss://soa.webhok.hokkj.cn/newApi'
if (process.env.CUSTOM_ENV === 'test') {
  wss = 'wss://test.cloud.hokkj.cn'
} else if (process.env.CUSTOM_ENV === 'dev') {
  wss = 'wss://dev.cloud.hokkj.cn'
} else if (process.env.CUSTOM_ENV === 'beta') {
  wss = 'wss://beta.cloud.hokkj.cn'
}
let soa = 'soa.'
if (process.env.CUSTOM_ENV === 'test') {
  soa = 'test.'
} else if (process.env.CUSTOM_ENV === 'dev') {
  soa = 'dev.'
} else if (process.env.CUSTOM_ENV === 'beta') {
  soa = 'beta.'
}
export default {
  title: '伏羲云',
  favivon: '/favicon.ico',
  appName: '获客管理APP',
  aiAgent: false,
  ossUrl: 'https://oss.hokkj.cn', // 项目oss 图片
  VUE_APP_HUOSHAN_PSSTERURI: env
    ? `https://${env}cover.hokkj.cn/`
    : 'https://bscover.hokkj.cn/', // 火山封面图
  VUE_APP_BASE_AI_URL: wss, // AI助手 Socket url
  VUE_APP_ACTIVATION_URL: 'https://b1.hokkj.net/share?orderNo=',
  VUE_APP_QUESTIONNAIRE_URL: `https://${template}.hokkj.cn/questionnaire?id=`,
  VUE_APP_H5_URL: `https://${env}h3.hokkj.cn/`,
  VUE_APP_TEMPLATE_URL: `https://${template}.hokkj.cn`,
  VUE_APP_BASE_URL: `https://${soa}webhok.hokkj.cn/`,
  CLOUD_URL: `https://${env}cloud.hokkj.cn`,
  WELCOME_URL: 'https://hokvv.cn/BDXfqy',
  publicKey:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCpAPiHBGnFj2+9lPQ76fEhuQDUel8Jev2o0+Oc4hhIOEWzAyFACvpLWZyfrQi0x+0Q0ADmA391djK2kzNMgu1Ukx3jb+GT9Wqu/bl+QzgE02j1D8GOH9hjZ33QlGZmloKRxJE7LS6Psr9Jt5Zu0wS9ERU1qdfT58TJmdxcoZlzGQIDAQAB',
  downloadMocMedia: 'https://oss.hokkj.cn/yijianfabu/bos-client.dmg?t=',
  downloadAndriodMedia: 'https://oss.hokkj.cn/yijianfabu/bos-client.exe?t=',
  downloadMacLive: 'https://oss.hokkj.cn/common/HokFxyLive-macOS.dmg?t=',
  downloadAndriodLive:
    'https://oss.hokkj.cn/common/hokFxyLive_release_setup(x64).exe?t=',
  QUESION_URL: `https://bswq.fxyvv.com`
}
